import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

const styles = theme => ({
	wrapper:{
		width: "100%",
		height: "100%",
		padding: "5%",
	},
	imageLogo: {
		width: "85%",
		height: "60%",
		margin: "0 auto",
		borderRadius: "15px",
		background: "linear-gradient(-45deg, #e7e7e7 0%, #e7e7e7 45%, #F8F8F8 50%, #e7e7e7 75%, #e7e7e7 100%)",
		backgroundSize: "250% 250%",
		animation: "$pulse 0.7s cubic-bezier(0.55, 0.085, 0.68, 0.53) infinite;",
		"user-select": "none",
	},
	"@keyframes pulse": {
		"0%": {
			backgroundPosition: "-0% 0%"
		},

		"70%": {
			backgroundPosition: "-150% 0%"
		},

		"100%": {
			backgroundPosition: "-150% 0%"
		},
	}
});

function SkeletonLogo (props) {
	const { classes } = props;

		return (
			<div className={classes.wrapper}>
				<div className={classes.imageLogo}/>
			</div>
		);
}

// solvedDate
// wikipediaUrl

SkeletonLogo.propTypes = {
	classes: PropTypes.shape({
		imageLogo: PropTypes.string.isRequired,
	}).isRequired,
};

export default withStyles(styles)(SkeletonLogo);
